/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Fintecy Investors API
 * API for managing investors, accounts, and transactions in the Fintecy platform
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';

import type {
  Error,
  GetNotificationsParams,
  MarkAllReadResponse,
  Notification,
  NotificationsResponse,
} from '.././model';

import { customInstance } from '../../axios-instance';

/**
 * Returns a paginated list of notifications for the authenticated user
 * @summary Get user notifications
 */
export const getNotifications = (params?: GetNotificationsParams, signal?: AbortSignal) => {
  return customInstance<NotificationsResponse>({
    url: `/api/notifications`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetNotificationsQueryKey = (params?: GetNotificationsParams) => {
  return [`/api/notifications`, ...(params ? [params] : [])] as const;
};

export const getGetNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = Error,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) =>
    getNotifications(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>;
export type GetNotificationsQueryError = Error;

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = Error,
>(
  params: undefined | GetNotificationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = Error,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = Error,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get user notifications
 */

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = Error,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Marks a specific notification as read
 * @summary Mark notification as read
 */
export const markNotificationAsRead = (id: string, signal?: AbortSignal) => {
  return customInstance<Notification>({
    url: `/api/notifications/${id}/read`,
    method: 'POST',
    signal,
  });
};

export const getMarkNotificationAsReadMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationAsRead>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationAsRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['markNotificationAsRead'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationAsRead>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return markNotificationAsRead(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationAsRead>>
>;

export type MarkNotificationAsReadMutationError = Error;

/**
 * @summary Mark notification as read
 */
export const useMarkNotificationAsRead = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markNotificationAsRead>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationAsRead>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getMarkNotificationAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Marks all notifications as read for the authenticated user
 * @summary Mark all notifications as read
 */
export const markAllNotificationsAsRead = () => {
  return customInstance<MarkAllReadResponse>({
    url: `/api/notifications/read-all`,
    method: 'PATCH',
  });
};

export const getMarkAllNotificationsAsReadMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['markAllNotificationsAsRead'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
    void
  > = () => {
    return markAllNotificationsAsRead();
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllNotificationsAsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markAllNotificationsAsRead>>
>;

export type MarkAllNotificationsAsReadMutationError = Error;

/**
 * @summary Mark all notifications as read
 */
export const useMarkAllNotificationsAsRead = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getMarkAllNotificationsAsReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a specific notification
 * @summary Delete notification
 */
export const deleteNotification = (id: string) => {
  return customInstance<void>({ url: `/api/notifications/${id}`, method: 'DELETE' });
};

export const getDeleteNotificationMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteNotification>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteNotification>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteNotification'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteNotification>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteNotification(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteNotification>>
>;

export type DeleteNotificationMutationError = Error;

/**
 * @summary Delete notification
 */
export const useDeleteNotification = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteNotification>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteNotification>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteNotificationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
